import { PlanCoordinate } from '../../services/plan-coordinate';
import { StepComponent } from '../step.component';
import { ChangeDetectorRef } from '@angular/core';
import { ResourceService } from '../../services/resource.service';

export class DeliverableStepComponent extends StepComponent<void> {
  constructor(planCoordinate: PlanCoordinate, protected cdr: ChangeDetectorRef, _resourceService: ResourceService) {
    super(planCoordinate, _resourceService);
  }

  protected postSetVisible(isVisible: boolean) {
    if (isVisible) {
      this.cdr.detectChanges();
    }
  }
}
